import { app } from '../../app.module'
app
  /**
   * スクロール時に処理を実行(主にinfiniteScrollで使用)
   */
  .directive('scrollDown', function () {
    return {
      link: function (scope, element, attrs) {
        const raw = element[0]

        element.bind('scroll', function () {
          // Chromeブラウザの縮小機能を利用すると、スクロールのoffsetHeightの値が少し減るので、スクロールの位置を計算するために、合計に5pxを付けている
          // 一番下要素の高さを越える場合、追加でロードされる
          if (raw.scrollTop + raw.offsetHeight + 5 >= raw.scrollHeight) {
            scope.$apply(attrs.scrollDown)
          }
        })
      },
    }
  })
